import { useState } from 'react';
import AuthCard from './components/AuthCard';
import { showToastError } from './components/ToastNotifications';
import { useForgotPasswordRecovery } from './hooks/usePasswordRecovery';

type ForgotPasswordPageProps = {
  onSignIn: () => void;
  hasBackground?: boolean;
  defaultEmail?: string;
}

export default function ForgotPasswordPage({ onSignIn, hasBackground, defaultEmail }: ForgotPasswordPageProps) {
  const [email, setEmail] = useState(defaultEmail ?? '');
  const [sentEmail, setSentEmail] = useState<string | null>(null);
  const { submit, pending } = useForgotPasswordRecovery();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const submittedEmail = email;
    setSentEmail(null);
    const result = await submit(submittedEmail);
    if (result.kind === 'error') {
      showToastError('The password reset email could not be sent. Please try again.');
    } else if (result.kind === 'success') {
      setSentEmail(submittedEmail);
    }
  };

  return (
    <AuthCard
      pageTestId="page-forgot-password"
      cardTestId="forgot-password-form"
      ariaLabel="Forgot password"
      title="Reset your password"
      subtitle="We will send you a recovery link"
      hasBackground={hasBackground}
    >
      <form className="login-form" onSubmit={handleSubmit}>
          <label className="label">Email</label>
          <input
            type="email"
            className="input"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={pending}
            data-testid="forgot-password-email"
          />

          <button
            type="submit"
            className="button cta"
            style={{ width: '100%', marginTop: 8 }}
            data-testid="forgot-password-submit"
            disabled={pending}
            aria-busy={pending}
          >
            {pending ? 'Sending Recovery Link…' : 'Send Recovery Link'}
          </button>
          <button type="button" className="text-link" onClick={onSignIn} disabled={pending} data-testid="forgot-password-back-to-login">Back to sign in</button>
        </form>

        {sentEmail && (
          <div className="alert info" role="status" style={{ marginTop: -4, color: 'white' }} data-testid="forgot-password-sent">
            Password reset link sent to {sentEmail}. Check your inbox to continue.
          </div>
        )}
    </AuthCard>
  );
}
